import { DAYS_OF_WEEK, } from "./types/foyer";
import { localPartsInTimezone } from "./schedule";
import { minutesOfDay } from "./signage";
export function offerAvailabilityCovers(availability, parts) {
    var _a, _b;
    const a = availability !== null && availability !== void 0 ? availability : {};
    if (a.startDate && parts.ymd < a.startDate)
        return false;
    if (a.endDate && parts.ymd > a.endDate)
        return false;
    if (a.days && a.days.length > 0 && !a.days.includes(parts.day))
        return false;
    if (!a.startTime && !a.endTime)
        return true;
    const start = minutesOfDay((_a = a.startTime) !== null && _a !== void 0 ? _a : "00:00");
    const end = minutesOfDay((_b = a.endTime) !== null && _b !== void 0 ? _b : "00:00");
    if (start === end)
        return true;
    if (start < end)
        return parts.minutes >= start && parts.minutes < end;
    return parts.minutes >= start || parts.minutes < end;
}
export function offerIsLiveAt(offer, now, timezone) {
    if (!offer.enabled)
        return false;
    const parts = localPartsInTimezone(timezone, now);
    return offerAvailabilityCovers(offer.availability, {
        ymd: parts.ymd,
        day: parts.day,
        minutes: minutesOfDay(parts.hhmm),
    });
}
export const MAX_OFFER_SLOTS = 240;
const MINUTES_PER_DAY = 24 * 60;
function pad2(n) {
    return String(n).padStart(2, "0");
}
function hhmmOf(minutes) {
    return `${pad2(Math.floor(minutes / 60))}:${pad2(minutes % 60)}`;
}
export function addDaysYmd(ymd, days) {
    const [y, m, d] = ymd.split("-").map(Number);
    const at = new Date(Date.UTC(y !== null && y !== void 0 ? y : 1970, (m !== null && m !== void 0 ? m : 1) - 1, d !== null && d !== void 0 ? d : 1));
    at.setUTCDate(at.getUTCDate() + days);
    return `${at.getUTCFullYear()}-${pad2(at.getUTCMonth() + 1)}-${pad2(at.getUTCDate())}`;
}
export function weekdayOfYmd(ymd) {
    var _a;
    const [y, m, d] = ymd.split("-").map(Number);
    const at = new Date(Date.UTC(y !== null && y !== void 0 ? y : 1970, (m !== null && m !== void 0 ? m : 1) - 1, d !== null && d !== void 0 ? d : 1));
    return (_a = DAYS_OF_WEEK[(at.getUTCDay() + 6) % 7]) !== null && _a !== void 0 ? _a : "mon";
}
export function slotPolicyOf(action) {
    return (action === null || action === void 0 ? void 0 : action.kind) === "booking" ? action.slots : null;
}
export function offerIsSellable(action) {
    return (action === null || action === void 0 ? void 0 : action.kind) === "order" || (action === null || action === void 0 ? void 0 : action.kind) === "booking";
}
export function expandOfferSlots(policy, opts) {
    var _a, _b;
    if (!policy || policy.mode !== "slots")
        return [];
    if (slotPolicyProblems(policy).length > 0)
        return [];
    const parts = localPartsInTimezone(opts.timezone, opts.now);
    const cutoff = minutesOfDay(parts.hhmm) + ((_a = policy.minNoticeMinutes) !== null && _a !== void 0 ? _a : 0);
    const first = minutesOfDay(policy.startTime);
    const last = minutesOfDay(policy.endTime);
    const limit = Math.min((_b = opts.limit) !== null && _b !== void 0 ? _b : MAX_OFFER_SLOTS, MAX_OFFER_SLOTS);
    const out = [];
    for (let offset = 0; offset < policy.horizonDays; offset++) {
        const date = addDaysYmd(parts.ymd, offset);
        const day = weekdayOfYmd(date);
        if (policy.days.length > 0 && !policy.days.includes(day))
            continue;
        for (let t = first; t < last; t += policy.intervalMinutes) {
            if (offset * MINUTES_PER_DAY + t < cutoff)
                continue;
            const time = hhmmOf(t);
            out.push({
                start: `${date}T${time}`,
                date,
                time,
                day,
                capacity: policy.capacity,
            });
            if (out.length >= limit)
                return out;
        }
    }
    return out;
}
const HHMM_RE = /^([01]\d|2[0-3]):[0-5]\d$/;
const YMD_RE = /^\d{4}-\d{2}-\d{2}$/;
export const MAX_HORIZON_DAYS = 30;
function isPositiveInt(v, min, max) {
    return typeof v === "number" && Number.isInteger(v) && v >= min && v <= max;
}
export function moneyProblems(price) {
    if (price === undefined)
        return [];
    const out = [];
    if (typeof price.amount !== "number" ||
        !Number.isFinite(price.amount) ||
        price.amount < 0) {
        out.push("price_amount_invalid");
    }
    if (typeof price.currency !== "string" ||
        price.currency.trim() === "" ||
        price.currency.length > 8) {
        out.push("price_currency_invalid");
    }
    return out;
}
export function offerAvailabilityProblems(availability) {
    if (availability == null)
        return [];
    const out = [];
    const { startDate, endDate, days, startTime, endTime } = availability;
    if (startDate !== undefined && !YMD_RE.test(startDate)) {
        out.push("availability_start_date_invalid");
    }
    if (endDate !== undefined && !YMD_RE.test(endDate)) {
        out.push("availability_end_date_invalid");
    }
    if (startDate && endDate && YMD_RE.test(startDate) && YMD_RE.test(endDate)) {
        if (endDate < startDate)
            out.push("availability_dates_reversed");
    }
    if (days !== undefined) {
        if (!Array.isArray(days) || days.some((d) => !DAYS_OF_WEEK.includes(d))) {
            out.push("availability_days_invalid");
        }
    }
    if (startTime !== undefined && !HHMM_RE.test(startTime)) {
        out.push("availability_start_time_invalid");
    }
    if (endTime !== undefined && !HHMM_RE.test(endTime)) {
        out.push("availability_end_time_invalid");
    }
    return out;
}
export function slotPolicyProblems(policy) {
    var _a, _b;
    if (!policy || typeof policy !== "object")
        return ["slots_missing"];
    if (policy.mode === "asap")
        return [];
    if (policy.mode !== "slots")
        return ["slots_mode_invalid"];
    const out = [];
    if (!Array.isArray(policy.days) ||
        policy.days.some((d) => !DAYS_OF_WEEK.includes(d))) {
        out.push("slots_days_invalid");
    }
    const startOk = HHMM_RE.test((_a = policy.startTime) !== null && _a !== void 0 ? _a : "");
    const endOk = HHMM_RE.test((_b = policy.endTime) !== null && _b !== void 0 ? _b : "");
    if (!startOk)
        out.push("slots_start_time_invalid");
    if (!endOk)
        out.push("slots_end_time_invalid");
    if (startOk &&
        endOk &&
        minutesOfDay(policy.endTime) <= minutesOfDay(policy.startTime)) {
        out.push("slots_window_not_forward");
    }
    if (!isPositiveInt(policy.intervalMinutes, 5, 720)) {
        out.push("slots_interval_invalid");
    }
    if (!isPositiveInt(policy.capacity, 1, 999))
        out.push("slots_capacity_invalid");
    if (!isPositiveInt(policy.horizonDays, 1, MAX_HORIZON_DAYS)) {
        out.push("slots_horizon_invalid");
    }
    if (policy.minNoticeMinutes !== undefined &&
        !isPositiveInt(policy.minNoticeMinutes, 0, 7 * 24 * 60)) {
        out.push("slots_notice_invalid");
    }
    return out;
}
export function offerActionProblems(action) {
    if (!action || typeof action !== "object")
        return ["action_missing"];
    switch (action.kind) {
        case "promotion": {
            const extra = action;
            return extra.price !== undefined || extra.slots !== undefined
                ? ["promotion_takes_no_price"]
                : [];
        }
        case "order":
            return [
                ...moneyProblems(action.price),
                ...(action.fulfil === "deliver" || action.fulfil === "desk"
                    ? []
                    : ["order_fulfil_invalid"]),
            ];
        case "booking":
            return [
                ...moneyProblems(action.price),
                ...slotPolicyProblems(action.slots),
            ];
        default:
            return ["action_kind_invalid"];
    }
}
export function offerItemsProblems(items) {
    if (items === undefined)
        return [];
    if (!Array.isArray(items))
        return ["items_invalid"];
    const out = [];
    const seen = new Set();
    for (const item of items) {
        if (!item || typeof item !== "object") {
            out.push("item_invalid");
            continue;
        }
        if (localizedIsBlank(item.label))
            out.push("item_label_required");
        const id = typeof item.id === "string" ? item.id.trim() : "";
        if (id) {
            if (seen.has(id))
                out.push("item_id_duplicated");
            seen.add(id);
        }
        out.push(...moneyProblems(item.price));
    }
    return [...new Set(out)];
}
function localizedIsBlank(value) {
    if (value == null)
        return true;
    if (typeof value === "string")
        return value.trim() === "";
    return !Object.values(value).some((v) => typeof v === "string" && v.trim());
}
export function roomOfferProblems(input, opts = {}) {
    var _a;
    const out = [];
    if ((opts.creating || input.title !== undefined) &&
        localizedIsBlank(input.title)) {
        out.push("title_required");
    }
    if (input.action !== undefined)
        out.push(...offerActionProblems(input.action));
    if (input.availability !== undefined) {
        out.push(...offerAvailabilityProblems(input.availability));
    }
    if (input.items !== undefined)
        out.push(...offerItemsProblems(input.items));
    if (((_a = input.action) === null || _a === void 0 ? void 0 : _a.kind) === "promotion" &&
        input.items !== undefined &&
        input.items.length > 0) {
        out.push("promotion_takes_no_items");
    }
    return out;
}
export function offerStatusAt(offer, now, timezone) {
    var _a;
    if (!offer.enabled)
        return "off";
    const parts = localPartsInTimezone(timezone, now);
    const a = (_a = offer.availability) !== null && _a !== void 0 ? _a : {};
    if (a.endDate && parts.ymd > a.endDate)
        return "ended";
    if (a.startDate && parts.ymd < a.startDate)
        return "scheduled";
    const minutes = minutesOfDay(parts.hhmm);
    if (offerAvailabilityCovers(a, { ymd: parts.ymd, day: parts.day, minutes })) {
        return "live";
    }
    return a.endDate &&
        parts.ymd === a.endDate &&
        !comesBackToday(a, parts.day, minutes)
        ? "ended"
        : "scheduled";
}
export function offerStatusReason(offer, now, timezone) {
    var _a;
    if (!offer.enabled)
        return undefined;
    const a = (_a = offer.availability) !== null && _a !== void 0 ? _a : {};
    const parts = localPartsInTimezone(timezone, now);
    if (a.endDate && parts.ymd > a.endDate)
        return `ended ${a.endDate}`;
    if (a.startDate && parts.ymd < a.startDate)
        return `from ${a.startDate}`;
    const minutes = minutesOfDay(parts.hhmm);
    if (offerAvailabilityCovers(a, { ymd: parts.ymd, day: parts.day, minutes })) {
        return undefined;
    }
    if (a.days && a.days.length > 0 && !a.days.includes(parts.day)) {
        return a.days.join(", ");
    }
    if (a.startTime && a.endTime && a.startTime !== a.endTime) {
        return `${a.startTime}-${a.endTime}`;
    }
    return undefined;
}
function comesBackToday(a, day, minutes) {
    var _a, _b;
    if (a.days && a.days.length > 0 && !a.days.includes(day))
        return false;
    if (!a.startTime && !a.endTime)
        return false;
    const start = minutesOfDay((_a = a.startTime) !== null && _a !== void 0 ? _a : "00:00");
    const end = minutesOfDay((_b = a.endTime) !== null && _b !== void 0 ? _b : "00:00");
    if (start === end)
        return false;
    if (start > end)
        return true;
    return minutes < start;
}
